import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQuestionStatusIncorrectAiIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "path-1-inside-1_8682_98",
			fill: "white",
			children: /* @__PURE__ */ _jsx("path", { d: "M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z" })
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z",
			fill: "#633BEE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 8M16 8M16 8M0 8M8 0M16 8M8 16M0 8M8 16V14.8922C4.19352 14.8922 1.10776 11.8065 1.10776 8H0H-1.10776C-1.10776 13.0301 2.96992 17.1078 8 17.1078V16ZM16 8H14.8922C14.8922 11.8065 11.8065 14.8922 8 14.8922V16V17.1078C13.0301 17.1078 17.1078 13.0301 17.1078 8H16ZM8 0V1.10776C11.8065 1.10776 14.8922 4.19352 14.8922 8H16H17.1078C17.1078 2.96992 13.0301 -1.10776 8 -1.10776V0ZM8 0V-1.10776C2.96992 -1.10776 -1.10776 2.96992 -1.10776 8H0H1.10776C1.10776 4.19352 4.19352 1.10776 8 1.10776V0Z",
			fill: "#633BEE",
			mask: "url(#path-1-inside-1_8682_98)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 5L5 11",
			stroke: "white",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 11L5 5",
			stroke: "white",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgQuestionStatusIncorrectAiIcon;
